import script from "./BlockTransactionPaymentMethod.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockTransactionPaymentMethod.vue?vue&type=script&setup=true&lang=js"

import "./BlockTransactionPaymentMethod.vue?vue&type=style&index=0&id=1399b29b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1399b29b"]])

export default __exports__